export default {
	SET_FAQS_CONTENT: (state, data) => {
        state.faqGroups = {
            ...state.faqGroups,
            ...data
        };
    },
}